module.exports = __webpack_public_path__ + "static/media/filter.5b918444.svg";